// #TODO 30-04-2018_FG Terminer les interfaces
import { Yii } from "libraries/interfaces/Yii";
import { faCheck, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IHotel, IHotelConfig } from 'libraries/hotel/models/hotel';
import { IQuoteRequest } from 'libraries/service/resources/hotel/ISearchParameters';
import { ICurrencies } from 'libraries/service/resources/hotel/ISearchResponse';
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { SharedData } from "libraries/hotel/shared-data";
import { EStayPermissions } from "libraries/enums/e-stay-permissions";

export interface IGetQuotes {
    request: IQuoteRequest;
    hotelInformations: IHotel;
}

class Wording {
    public readonly choose: string = Yii.t('wui-iqbh-js', 'Choisir');
}


@Component({
    selector: 'hotel',
    template: `
        <div class="hotel">
            <div class="selected-hotel" id="{{ isSelectedHotel ? 'selected-hotel' : ''}}">
                <fa-icon *ngIf="isSelectedHotel" [icon]="iconCheck"></fa-icon>
            </div>

            <hotel-resume (onGetQuotes)="getQuotes($event)"
                          [hotel]="hotel"
                          [currency]="currency"
                          [currencies]="currencies"
                          [isShowRooms]="true"
                          [mealPlan]="hotel.mealplan">
            </hotel-resume>

            <ng-container>
                <div *ngIf="config; else noConfig" class="hotel-btn-container">
                    <btn class="hovervisible"
                         class="isSelected"
                         *ngFor="let button of config.buttons"
                         type="actionDo"
                         [value]="button.label"
                         (onClick)="this[button.internalFunctionName](hotel)">
                    </btn>
                </div>
            </ng-container>

            <ng-template #noConfig>
                <div class="hotel-btn-container">
                    <btn *ngIf="isSelectable"
                         class="hovervisible"
                         type="actionDo"
                         [value]="wording.choose"
                         (onClick)="getQuotation(hotel)"></btn>
                </div>

            </ng-template>

        </div>
    `,
    styleUrls: ['./hotel.component.scss']
})
export class HotelComponent {
    @Input()
    public hotel: IHotel;
    @Input()
    public isShowRooms: boolean;
    @Input()
    public isSelectable: boolean = true;

    @Input()
    public config: IHotelConfig;

    @Output()
    public readonly onGetHotelQuote: EventEmitter<IGetQuotes> = new EventEmitter<IGetQuotes>();

    @Output()
    public readonly onGetQuotation: EventEmitter<IGetQuotes> = new EventEmitter<IGetQuotes>();
    @Output()
    public readonly onInsert: EventEmitter<IGetQuotes> = new EventEmitter<IGetQuotes>();

    @Input()
    public currencies: ICurrencies;

    @Input()
    public isSelectedHotel: boolean = false;

    @Input()
    public currency: ICurrency;

    public iconCheck: IconDefinition = faCheck;

    public wording: Wording = new Wording();

    constructor(
        private readonly sharedData: SharedData,
    ) {
    }

    public getQuotes(hotel: IHotel): void {
        this.sharedData.setData('hotelDetail', hotel);
        const request: IQuoteRequest = {
            trips: hotel.trip,
            properties: hotel.syscode,
            hosts: hotel.host as string,
        };

        this.onGetHotelQuote.emit({request, hotelInformations: hotel});
    }

    public getQuotation(hotelInformations: IHotel): void {
        this.sharedData.setData('hotelDetail', hotelInformations);

        this.onGetQuotation.emit(
            {
                request: {
                    trips: hotelInformations.trip,
                    hosts: hotelInformations.host as string,
                    properties: hotelInformations.syscode
                },
                hotelInformations
            }
        );
    }

    public insertQuote(hotel: IHotel): void {
        this.sharedData.setData('hotelDetail', hotel);
        const request: IQuoteRequest = {
            trips: hotel.trip,
            properties: hotel.syscode,
            hosts: hotel.host as string,
        };

        this.onInsert.emit({request, hotelInformations: hotel});
    }

    public permissions: typeof EStayPermissions = EStayPermissions;
}
